import React from "react";
import { useIntl } from "react-intl";
import { type ISelectInputProps, SelectInput } from "./SelectInput";
import Required from "shared/forms/validations/Required";

export interface IStoreInputProps extends ISelectInputProps {
  isRequired?: boolean;
}
export const StoreInput = ({ isRequired, ...rest }: IStoreInputProps) => {
  const { formatMessage } = useIntl();
  return (
    <SelectInput
      validate={isRequired ? [Required] : undefined}
      selectText={formatMessage({
        id: "landing.subscription.field.select_store",
      })}
      {...rest}
    />
  );
};
